import React from "react";
import PropTypes from "prop-types";
import { CustomIconButton } from "./customButton";

const SFIconButton = (props) => {
  return (
    <CustomIconButton
      {...props}
    >
      {props.children}
    </CustomIconButton>
  );
};

SFIconButton.defaultProps = {
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  ariaLabel: null,
};

SFIconButton.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  ariaLabel: PropTypes.string
};

export default SFIconButton;
